/**
 * @ngdoc directives
 * @memberof mercury.directives
 * @name googlechart
 * @description Displays a chart using the Google Charting Library
 * @attr {Object} ng-model The data to be used to draw the chart
 * @attr {Object} columns An array of columns for the chart.
 * @attr {String} googlechart A string to say what kind of column to draw
 * @attr {Object} options An object of options that will be merged with the chart defaults
 */
angular.module('mercury.directives.googlechart', [])
.directive('googlechart', ["$rootScope", "$filter", "$parse", "$timeout", "$window", function($rootScope, $filter, $parse, $timeout, $window) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function(scope, element, attrs) {
      var chart = null;

      var animationDisabled = false;

      // Given column definitions and an array of data, build a DataTable readable format
      var buildDataTable = function(columns, data) {
        var filter = $parse(attrs.filter)(scope);
        var filterColumns = $parse(attrs.filterColumns)(scope);
        if (filter) {
          data = $filter('filter')(data, function(row) {
            var match = false;
            angular.forEach(filterColumns, function(column) {
              match = match || row[column].toLowerCase().indexOf(filter) != -1;
            });
            return match;
          });
        }

        var graphRows = [];
        angular.forEach(data, function(dataRow) {
          var row = {c: []};
          var ignoreRow = false;

          angular.forEach(columns, function(column) {
            var value = dataRow[column.key];

            if (column.filter) {
              row.c.push({v: value, f: $filter(column.filter)(value)});
            } else {
              row.c.push({v: value});
            }

            // Pie charts don't allow negative values so if a row contains one, ignore it.
            if (attrs.googlechart == 'piechart' && typeof value == 'number' && value < 0) {
              ignoreRow = true;
            }

          });

          if (!ignoreRow) {
            graphRows.push(row);
          }
        });

        return {
          cols: columns,
          rows: graphRows
        };
      };

      var draw = function() {
        var graphData = $parse(attrs.ngModel)(scope);

        if (graphData) {
          // If the columns attribute is defined, the columns for this graphs DataTable,
          // are defined separately. We can build the data table from the column definitions
          // and supplied graph data.
          if (attrs.columns) {
            graphData = buildDataTable($parse(attrs.columns)(scope), graphData);
          }

          // The default maxValue is 1000. This is so the graph looks good if there is no data.
          var maximumValue = 0;
          var minimumValue = 0;

          angular.forEach(graphData.rows, function(row) {
            angular.forEach(row.c, function(column) {
              if (typeof column.v === 'number') {
                maximumValue = Math.max(maximumValue, column.v);
                minimumValue = Math.min(minimumValue, column.v);
              }
            });
          });

          if (maximumValue === 0) {
            maximumValue = 1000;
          }

          var leftSpace;
          var rightSpace = 0;
          if (Math.abs(maximumValue) > Math.abs(minimumValue)) {
            leftSpace = (Math.log(Math.abs(maximumValue)) + 2) * 4 + 30;
          } else {
            leftSpace = (Math.log(Math.abs(minimumValue)) + 3) * 4 + 30;
          }

          // bit of a hack to allow us to leave extra space if we need a second y axis on the right hand side
          if (angular.isDefined(attrs.options)) {
            var opts = $parse(attrs.options)(scope);
            if (angular.isDefined(opts) &&
              angular.isDefined(opts.vAxes) &&
              opts.vAxes.length > 1 &&
              angular.isDefined(opts.vAxes[1].minValue) &&
              angular.isDefined(opts.vAxes[1].maxValue)) {
              // second axis is the right hand one
              var axisMinimum = opts.vAxes[1].minValue;
              var axisMaximum = opts.vAxes[1].maxValue;

              if (Math.abs(axisMaximum) > Math.abs(axisMinimum)) {
                rightSpace = (Math.log(Math.abs(axisMaximum)) + 2) * 4 + 30;
              } else {
                rightSpace = (Math.log(Math.abs(axisMinimum)) + 3) * 4 + 30;
              }
            }
          }

          var setChartColours = function(data) {

            var GP = [];

            if (data.rows.length < 6 && (attrs.googlechart == 'piechart' || attrs.googlechart == 'combochart')) {
              LdColorClass = 'graph-pietwo-color';
            } else if (attrs.palette) {
              LdColorClass = 'graph-' + attrs.palette + '-color';
            } else {
              LdColorClass = 'graph-default-color';
            }

            for (var iter = 1; iter < 22; iter++) {
              var tmpElement = $('<span class="' + LdColorClass + '-' + iter + '"></span>');
              $('body').append(tmpElement);
              GP.push(tmpElement.css('background-color'));
              tmpElement.remove();
            }

            return GP;
          };

          var GraphColors = setChartColours(graphData);

          // Default options
          var options = {
            // The height and width of the chart should fill the container
            colors: GraphColors,
            legend: {position: 'none'},
            fontSize: 12,
            height: $(element).height(),
            width: $(element).width(),
            chartArea: {
              top: 15,
              left: leftSpace,
              width: ($(element).width() - leftSpace - rightSpace - 20),
              height: $(element).height() - 80
            },
            hAxis: {
              slantedText: (graphData.rows.length > 7),
              baselineColor: 'white'
            },
            vAxis: {
              maxValue: maximumValue,
              format: '$#,###.##',
              gridlines: {
                color: '#eeecec',
              },
              minorGridlines: {
                color: '#eeecec',
              }
            },
            animation: (animationDisabled) ? null : {duration: 2000, startup: true, easing: 'out'}
          };

          if (attrs.googlechart == 'piechart') {
            $.extend(true, options, {
              pieSliceText: 'none',
              sliceVisibilityThreshold: 0.02,
              pieHole: 0.5,
              // legend: {
              //   position: 'right',
              //   alignment: 'center'
              // }
              chartArea: {
                left: 15,
                width: ($(element).width() - 15 - 15)
              },
              legend: {
                position: 'labeled'
              }
            });
          }

          if (angular.isDefined(attrs.options)) {
            $.extend(true, options, $parse(attrs.options)(scope));
          }

          if (options.onSelect) {
            google.visualization.events.addListener(chart, 'select', function() {
              var selected = chart.getSelection();

              options.onSelect(selected);
            });
          }

          chart.draw(new google.visualization.DataTable(graphData), options);
        }
      };

      // When this directive is destroyed, make sure we unbind the listener on the window.
      scope.$on('$destroy', function() {
        angular.element($window).off('resize.googleChart');
      });

      // Bind a function to the window to allow quick changes via the devtools
      window.__redraw = function() {
        draw()
      }

      // Wait for Google Charts to be loaded before we try to draw the graph,
      // when it is ready it'll get drawn and we'll set up a few listeners
      // to re-render if data changes or the window resizes.
      google.charts.setOnLoadCallback(function() {
        switch (attrs.googlechart) {
          case 'linechart':
            chart = new google.visualization.LineChart(element[0]);
          break;
          case 'columnchart':
            chart = new google.visualization.ColumnChart(element[0]);
          break;
          case 'areachart':
            chart = new google.visualization.AreaChart(element[0]);
          break;
          case 'combochart':
            chart = new google.visualization.ComboChart(element[0]);
          break;
          case 'piechart':
            chart = new google.visualization.PieChart(element[0]);
          break;
        }

        // Initial Draw
        draw();

        // Watch the scope data for changes and redraw the graph.
        scope.$watch(attrs.ngModel, () => {
          draw()
        });

        scope.$on('update.googleChart', function() {
          draw();
        });

        // Watch for a change in the window size and redraw the graph.
        angular.element($window).on('resize.googleChart', function() {
          // Disable animation on redraw because its U G L Y
          animationDisabled = true;
          draw();
        });
      });

}}}]);
